<template>
  <svg
    class="custom-icon"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="hotsposts-iconb">
      <g id="Vector">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 29.5C23.4558 29.5 29.5 23.4558 29.5 16C29.5 8.54416 23.4558 2.5 16 2.5C8.54416 2.5 2.5 8.54416 2.5 16C2.5 23.4558 8.54416 29.5 16 29.5ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        />
        <path
          d="M24.9994 16.0001C24.9994 20.9706 20.97 25.0001 15.9994 25.0001C11.0289 25.0001 6.99944 20.9706 6.99944 16.0001C6.99944 11.0295 11.0289 7.00006 15.9994 7.00006C20.97 7.00006 24.9994 11.0295 24.9994 16.0001ZM13.3994 16.0001C13.3994 17.436 14.5635 18.6001 15.9994 18.6001C17.4354 18.6001 18.5995 17.436 18.5995 16.0001C18.5995 14.5641 17.4354 13.4 15.9994 13.4C14.5635 13.4 13.3994 14.5641 13.3994 16.0001Z"
        />
      </g>
    </g>
  </svg>
</template>
